// extracted by mini-css-extract-plugin
export default {"wrap":"Breadcrumbs_wrap__CMRtP","text":"Breadcrumbs_text__6TX+c","icon":"Breadcrumbs_icon__NSgl6"};